// Utility functions for URL obfuscation
const SALT = 'mst'; // ScanTag salt

export const encodeId = (id) => {
  if (!id) return '';
  try {
    // Remove any existing encoding to prevent double-encoding
    const cleanId = decodeId(id) || id;
    // Combine the ID with salt
    const combined = `${SALT}${cleanId}`;
    // Convert to base64 and remove special characters
    const encoded = btoa(combined)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
    return encoded;
  } catch (e) {
    console.error('Error encoding ID:', e);
    return '';
  }
};

export const decodeId = (hash) => {
  if (!hash) return '';
  try {
    // Check if the hash is already decoded
    if (hash.startsWith(SALT)) {
      return hash.slice(SALT.length);
    }
    // Restore base64 special characters
    const restored = hash
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    // Decode base64
    const decoded = atob(restored);
    // Extract the original ID (remove salt)
    if (!decoded.startsWith(SALT)) {
      return '';
    }
    return decoded.slice(SALT.length);
  } catch (e) {
    console.error('Error decoding hash:', e);
    return '';
  }
}; 